<script>
  import { onMount } from "svelte"
  import {
    page,
  } from '@inertiajs/svelte'

  let body = $page.props.Templates.comparison
</script>
{@html body}
